import { computed, watch } from 'vue'
import log from 'loglevel'
import store from '@/store/index.js'
import { LOCAL_STORAGE_USER_LIST_SETTING_KEY } from '@/constants.js'

/**
 * リストタブの表示設定を localStorage に永続化する
 */
export function useStoreListSetting() {
  /**
   * リスト表示設定(監視用)
   * @type {Object}
   */
  const listSetting = computed(() => {
    return JSON.stringify(store.getters['listViewSetting'])
  })

  /**
   * localStorage からリスト表示設定を復元する
   */
  const restoreListSettingFromLocalStorage = () => {
    log.debug('[DEBUG] try restore list setting from localStorage')
    const listSetting = _getListSettingFromLocalStorage()
    // ログインユーザーの設定を読み出す
    if (listSetting && listSetting[store.state.login.userId]) {
      log.debug(
        '[DEBUG] list setting found in localStorage',
        listSetting[store.state.login.userId]
      )
      store.commit('updateUserListState', listSetting[store.state.login.userId])
    } else {
      // 設定がない場合はクリア
      store.commit('updateUserListState', {
        columnStates: [],
        condition: {},
      })
    }
  }

  /**
   * localStorage からリスト表示設定を取得する
   */
  const _getListSettingFromLocalStorage = () => {
    const value = localStorage.getItem(LOCAL_STORAGE_USER_LIST_SETTING_KEY)
    try {
      return value ? JSON.parse(value) : null
    } catch (e) {
      log.debug('[DEBUG] failed to parse', value, e)
      return null
    }
  }

  /**
   * localStorage にリスト表示設定を保存する
   */
  const saveListSettingToLocalStorage = () => {
    const current = _getListSettingFromLocalStorage()
    const merged = JSON.stringify({
      ...current,
      [store.state.login.userId]: store.getters['listViewSetting'],
    })
    log.debug('[DEBUG] save list setting to localStorage', merged)
    localStorage.setItem(LOCAL_STORAGE_USER_LIST_SETTING_KEY, merged)
  }

  // listSetting に変化があったら localStorage に保存
  watch(listSetting, (value) => {
    value && saveListSettingToLocalStorage()
  })

  return {
    restoreListSettingFromLocalStorage,
    saveListSettingToLocalStorage,
  }
}
